"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _ = require("..");

var _UserForm = require("./UserForm.styles");

const CreateUserForm = ({
  error,
  formData,
  onChange,
  rolesSelectOptions,
  groupOptions
}) => {
  const formatGroup = selectedGroup => selectedGroup.map(({
    value
  }) => value);

  const formatRole = selectedRole => selectedRole.value;

  return /*#__PURE__*/_react.default.createElement(_UserForm.Container, null, /*#__PURE__*/_react.default.createElement(_.MsgAlert, {
    type: "error",
    message: error
  }), /*#__PURE__*/_react.default.createElement(_blocks.FieldText, {
    name: "email",
    type: "email",
    label: "Email",
    placeholder: "Email",
    value: formData.email || '',
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement(_blocks.FieldText, {
    name: "fullName",
    type: "text",
    label: "Full Name",
    placeholder: "Full Name",
    value: formData.fullName || '',
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement(_UserForm.Hr, null), /*#__PURE__*/_react.default.createElement(_blocks.FieldSelect, {
    className: "t-SelectRole",
    label: "Role",
    name: "role",
    placeholder: "Select...",
    options: rolesSelectOptions,
    onChange: value => onChange(formatRole(value), 'role'),
    menuPosition: "fixed"
  }), /*#__PURE__*/_react.default.createElement(_blocks.FieldSelect, {
    className: "t-SelectGroup",
    label: "Group",
    name: "groups",
    isMulti: true,
    placeholder: "Select...",
    options: groupOptions,
    onChange: selectedItems => onChange(formatGroup(selectedItems), 'groups'),
    menuPosition: "fixed"
  }));
};

var _default = CreateUserForm;
exports.default = _default;
module.exports = exports.default;